import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { NzLoginComponent } from "./nz-login.component";

import { NzButtonModule } from "../button/nz-button.module";
import { LoginServiceService } from "./login-service.service";

@NgModule({
  imports: [CommonModule, NzButtonModule],
  declarations: [NzLoginComponent],
  exports: [NzLoginComponent],
  providers: [LoginServiceService]
})
export class NzLoginModule {}
